// extracted by mini-css-extract-plugin
module.exports = {"bookingHeader":"styles_bookingHeader__fbSRV","ancillaries":"styles_ancillaries__qyX42"};